export const EMPLOYEE_IMPORTER_PATHS = [
  "/employee-data-importer",
  "/employee-data-importer-v2",
] as const;
